export const progressBar0 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar0.svg"

export const progressBar1 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar1.svg"

export const progressBar2 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar2.svg"

export const progressBar3 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar3.svg"

export const progressBar4 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar4.svg"

export const progressBar5 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar5.svg"

export const progressBar6 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar6.svg"

export const progressBar7 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar7.svg"

export const progressBar8 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar8.svg"

export const progressBar9 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar9.svg"

export const progressBar10 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar10.svg"

export const progressBar11 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar11.svg"

export const progressBar12 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar12.svg"

export const progressBar13 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar13.svg"

export const progressBar14 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar14.svg"

export const progressBar15 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar15.svg"

export const progressBar16 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar16.svg"

export const progressBar17 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar17.svg"

export const progressBar18 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar18.svg"

export const progressBar19 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar19.svg"

export const progressBar20 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar20.svg"

export const progressBar21 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar21.svg"

export const progressBar22 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar22.svg"

export const progressBar23 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar23.svg"

export const progressBar24 =
  "https://static.igem.wiki/teams/4380/wiki/progressbar/progressbar24.svg"

const progressBars = [
  progressBar0,
  progressBar1,
  progressBar2,
  progressBar3,
  progressBar4,
  progressBar5,
  progressBar6,
  progressBar7,
  progressBar8,
  progressBar9,
  progressBar10,
  progressBar11,
  progressBar12,
  progressBar13,
  progressBar14,
  progressBar15,
  progressBar16,
  progressBar17,
  progressBar18,
  progressBar19,
  progressBar20,
  progressBar21,
  progressBar22,
  progressBar23,
  progressBar24,
]

export default progressBars
